import nativeApi from '@/utils/native-api'
import {
  getDeadlineTime
} from '@/utils/time-utility'
import queryString from '@/utils/query-string'
import wxPayToken from '@/api/wxPayToken'
import localStorage from '@/utils/localStorage'
import env from '@/utils/env'
import hlid from '@/DATA/hlid.js';
import auth from '@/auth'

function getHlid(ptid) {
  let result;

  if (ptid) {
    result = hlid.web[ptid] || hlid.web.others;
  } else if (env.isQuickApp) {
    result = hlid.quickApp[env.quickappBrand] || hlid.quickApp.others;
  } else if (env.isNative) {
    result = hlid.native[env.appName] || hlid.native.gtgj;
  } else {
    result = hlid.web.others;
  }

  return result;
}

const H5_PAY_URL = "https://h5.133.cn/hangban/h5pay"
const H5_PAY_URL_NEW = "https://h5.133.cn/payment/h5"

/**
 * params参数:
 * @payUrl服务器端返回支付链接
 */
export const nativePay = (payUrl, tips = '') => {
  let params = queryString.parse(payUrl)
  if (tips && params.url) {
    params.url = `${params.url}&tips=${encodeURIComponent(tips)}`
  }

  return nativeApi.invoke("startPay", params).then((data) => {
    let result

    if (data && data.SUCC == data.value) {
      result = Promise.resolve(data)
    } else {
      result = Promise.reject({
        code: 0,
        message: '支付失败'
      })
    }

    return result
  })
}
/**
 * params参数:
 * @payId
 * @payTitle
 * @payDesc
 * @payImg
 * @disableStatePage
 * @ru支付成功页面跳转地址
 * @replace是否用replace替换当前页面
 */
export const h5Pay = (params = {}) => {
  wxPayToken.getWxPayToken(params).then(data => {
    gotoHbPayUrl(data, params.ru, params.replace)
  }).catch(this.$apiErrorHandler)
}
/**
 * 航班新支付
 * params参数:
 * @payOrderId
 * @expireMinute(超时时间单位分钟)
 * @orderBrief(string)
 * @successPage
 * @origin
 */
export const h5PayV2 = (params = {}) => {
  handlePaymentParams(params)

  if (params.orderBrief) {
    params.orderBrief = JSON.stringify(params.orderBrief)
  }

  if (!params.expireMinute) {
    params.expireMinute = 5
  }

  return wxPayToken.getWxPayTokenV2(params).then(data => {
    gotoHbPayUrlV2(data)
  }).catch(this.$apiErrorHandler)
}

// 航班新收银台接入
// (之前的收银台没人维护了，建议用这个)
export const h5PayV3 = (params = {}) => {
  const ptid = localStorage.get('ptid') || '';
  params.hlid = getHlid(ptid);
  return Promise.resolve().then(() => {
    gotoHbPayUrlV3(params)
  })
}

export const miniPay = ({type, title, orderId, payId, url}) => {
  const cashierUrlMap = new Map([
    ['gtgj', '/projects/payment2/pages/cashier'],
    ['hbgj', '/projects/payment2/pages/cashier']
  ])
  const redirectUrl = url.charAt(0) === '/' ? url : '/' + url
  const desc        = JSON.stringify({name: 'default', data:{title: title}})

  // eslint-disable-next-line
  wx.miniProgram.getEnv(res => {
    if(res.miniprogram) {
      // eslint-disable-next-line
      wx.miniProgram.navigateTo({
        url: `${cashierUrlMap.get(type || 'gtgj')}?orderid=${orderId}&payorderid=${payId}&template=${desc}&ru=${redirectUrl}`
      })
    }
  })
}

function handlePaymentParams(params) {
  if (!params.origin) {
    params.origin = 'web'
  } // 必选
  const ptid = localStorage.get('ptid') || '';
  const origins = ['jdbtpay', 'abc-app', 'cgg'];

  if (env.isDingTalk) {
    params.hideSpecPay = 'weixinpay'
  } else if (ptid === 'qqapp-hbgj') {
    params.hideSpecPay = 'weixinpay,alipay'
  } else if (origins.indexOf(ptid) >= 0) {
    params.origin = ptid
  }
}

function gotoHbPayUrl({
  token,
  expiredTime
}, ru = '', replace = false) {
  let {
    duration
  } = getDeadlineTime(expiredTime)
  duration = Math.floor(duration / 1000)

  let url = `${H5_PAY_URL}?token=${encodeURIComponent(token)}&timer=${duration}&ru=${encodeURIComponent(ru || '')}`

  //跳转到航班H5支付页
  if (replace) {
    location.replace(url)
  } else {
    location.href = url
  }
}

function gotoHbPayUrlV2({
  token
}) {
  let url = `${H5_PAY_URL}?iToken=${encodeURIComponent(token)}`

  //跳转到航班H5支付页
  if (localStorage.get('isReplaceWxPayPage')) {
    location.replace(url)
  } else {
    location.href = url
  }

  //清理
  localStorage.remove("isReplaceWxPayPage")
}

function gotoHbPayUrlV3({
  orderid,
  payorderid,
  template,
  ru,
  hlid
}) {
  auth.getToken().then((res) => {
    let authcode = res.authcode || '';
    let uid = localStorage.get("gtgj.deviceInfo").uid || '';
    let openid = localStorage.get('hbOpenid') || '';
    const ptid = localStorage.get('ptid') || '';
    let url = `${H5_PAY_URL_NEW}?authcode=${authcode}&uid=${uid}&orderid=${orderid}&payorderid=${payorderid}&ru=${encodeURIComponent(ru || '')}&template=${template && encodeURIComponent(JSON.stringify(template)) || ''}&openid=${openid}&hlid=${hlid}&hlsource=${ptid}`
    //跳转到航班H5支付页
    if (localStorage.get('isReplaceWxPayPage')) {
      location.replace(url)
    } else {
      location.href = url
    }

    //清理
    localStorage.remove("isReplaceWxPayPage")
  })

}



// WEBPACK FOOTER //
// ./src/utils/payHandler.js